import { query, createAsync } from "@solidjs/router";
import { _retrieveCVCCounts } from "../roma-api/cvc";

export const getCVCCounts = query(() => _retrieveCVCCounts(), "cvc-counts");

export const useCVCCounts = (
  options: { deferStream: boolean } = { deferStream: false }
) => createAsync(() => getCVCCounts(), options);
